<template>
  <div class="user-bar">
    <div class="title">
      <p :class="{ active: active == 0 }" @click="$router.push('/mine')">
        <i class="el-icon-s-home">我的参会信息</i>
      </p>
      <p :class="{ active: active == 1 }" @click="$router.push('/editpwd')">
        <i class="el-icon-user-solid">个人信息修改</i>
      </p>
    </div>
    <div class="user-info">
      <div class="user-name">
        <i class="icon el-icon-user">{{ userName || "" }}</i>
      </div>
      <div class="login-out">
        <i class="icon el-icon-switch-button" @click="logout()">登出</i>
      </div>
    </div>
    <!-- 参数图片 -->
    <div class="canhui">
      <img
        src="@/assets/image/canhui.png"
        alt=""
        @click="$router.push('/baoming')"
      />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { loginout } from "../../request/api/user";
export default {
  name: "",
  data() {
    return {};
  },
  computed: {
    userName() {
      return this.$store.state.userInfo.loginName || "匿名";
    },
    active() {
      return this.$store.state.menuactive;
    },
  },
  created() {},
  mounted() {},
  methods: {
    logout() {
      loginout({})
        .then((res) => {
          //安全退出
          this.$store.state.showLeftMenu = false;
          this.$store.state.showbg = true;
          localStorage.removeItem("islogin");
          localStorage.removeItem("userInfo");
          this.$store.commit("setUserInfo", "");
          this.$router.push({ path: "/login" });
          this.$notify({
            title: "提示",
            message: "安全退出",
            type: "success",
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="less">
.canhui {
  position: fixed;
  right: 0;
  top: 390px;
  z-index: 5;

  img {
    cursor: pointer;
  }
}
.user-bar {
  width: 1250px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #0060aa;
  padding: 30px 0 0px 0;
  margin-bottom: 30px;
  align-items: center;

  .title {
    font-size: 20px;

    font-weight: bold;
    display: flex;
    align-items: center;
    p {
      cursor: pointer;
      color: #999;
      width: 180px;
      margin-right: 30px;
      padding: 15px 10px;
      font-weight: bold;
      &.active {
        color: #0060aa;
        font-size: 22px;
        box-shadow: 1px 1px 5px #ddd;
      }
    }
  }

  .user-info {
    display: flex;
    color: #0060aa;
    font-size: 16px;

    .icon::before {
      margin-right: 8px;
    }

    .login-out {
      margin-left: 36px;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user-bar/user-bar.vue